import { useState } from 'react';
import { inputHasValue } from '../utils/FormUtils';

const useInputInfos = () => {
  const [inputInfos, setInputInfos] = useState([]);

  const handleInputInfo = (value) => {
    let foundedFieldValueIndex = inputInfos.findIndex(i => i.field === value.field);
    if (foundedFieldValueIndex >= 0) {
      // update existing inputInfo
      let inputInfosCopy = [...inputInfos];
      inputInfosCopy[foundedFieldValueIndex] = value;
      setInputInfos(inputInfosCopy);
    }
    else {
      // set initial input infos
      if (!inputInfos.some(i => i.field === value.field)) {
        setInputInfos(inputInfos => [...inputInfos, value] );
      }
    }
  };

  const getInputsStatusByInputInfos = (inputInfos) => {
    let hasValue = false;
    let hasError = true;

    if (inputInfos?.length > 0) {
        hasValue = Object.values(inputInfos).filter(i => i.isRequired).every(field => inputHasValue(field.value));
        hasError = Object.values(inputInfos).some(i => i.hasError);
    }

    return { hasValue, hasError };
  };

  return {
    inputInfos,
    setInputInfos,
    handleInputInfo,
    getInputsStatusByInputInfos
  };
}

export default useInputInfos;